import type { CreationTaskInput, TaskInfo } from '@/app/types';

export function getTaskInputs(task?: TaskInfo): CreationTaskInput | null {
  if (!task) return null;

  const { input, settings, type, scene } = task;
  const { prompts = [] } = input;

  const isProMode = input.editor_mode === 'professional';
  const textPrompt = prompts.filter((p) => p.type === 'text').map((p) => p.content)?.[0] || '';
  const mediaPrompts = prompts.filter((p) => p.type === 'image' || p.type === 'material' || p.type === 'video');
  const audioPrompts = prompts.filter((p) => p.type === 'text') || [];

  // 1.0 模型只有两个版本，vidu-high-quality 和 vidu-high-performance，此处兼容可能 modal 为 vidu 或者其他值
  if (settings.model_version === '1.0') {
    const currentModel = settings.model === 'vidu-high-quality' ? 'vidu-high-quality' : 'vidu-high-performance';
    settings.model = currentModel;
  }
  return {
    taskType: type,
    settings,
    mediaPrompts,
    audioPrompts,
    textPrompt,
    isProMode,
    templateScene: scene,
    prompts,
  };
}

export function getQuickEditToolUrl({ mode, creationId }: { mode: 'video' | 'image'; creationId?: string }): string {
  const params = new URLSearchParams();

  if (creationId) {
    params.set('creationId', creationId);
  }

  const basePath = mode === 'video' ? '/create/video-edit' : '/create/image-edit';
  const queryString = params.toString();

  return queryString ? `${basePath}?${queryString}` : basePath;
}

export function getQuickEditToolPath(mode: 'video' | 'image'): string {
  return mode === 'video' ? '/create/video-edit' : '/create/image-edit';
}

export function getExtensionToolUrl(creationId?: string): string {
  const params = new URLSearchParams();

  if (creationId) {
    params.set('creationId', creationId);
  }

  const queryString = params.toString();

  return queryString ? `/create/extension?${queryString}` : '/create/extension';
}

export function getExtensionToolPath(): string {
  return '/create/extension';
}
